  /* eslint-disable */
  import React, { useState } from "react";
  import styles from "./KanbanBoard.module.scss";
  import CandidateCard from "./CandidateCard";
  import Pagination from "@mui/material/Pagination";
  import { PiFunnelBold } from "react-icons/pi";
  import { LuRefreshCcw } from "react-icons/lu";
  import { useSelector, useDispatch } from "react-redux";

  import StateFilter from "../../pages/NewPipeline/InterviewPipeline/InterviewCreate/StateFilter";

  import { fetchPipeline, setPage } from "../../redux-store/slices/pipelineSlice";

  import Loader from "../Common/Loader/Loader";
  import { MyModal } from "../Common/Model/MyModal";
  import ModalContainer from "../Common/Model/ModalContainer";
import DetailContainer from "../CandidateDetailView/DetailContainer";

  const KanbanBoard = ({ stages = [], menu ,activeTab ,onSelectCandidate}) => {
    
    const dispatch = useDispatch();

    // ✅ REDUX DATA
    const { currentType, pipelineByType, loading } = useSelector(
      (state) => state.pipeline,
    );

    const {
      kanbanData = [],
      columnFilters = {},
      pageMap = {},
    } = pipelineByType[currentType] || {};

    // ✅ LOCAL STATE
    const [selectedStage, setSelectedStage] = useState(null);
    const [openFilter, setOpenFilter] = useState(false);
    const [isRotating, setIsRotating] = useState(null);

    // ✅ OPEN FILTER
    const handleFilterClick = (stageId, stageName) => {
      setSelectedStage({ id: stageId, stageName });
      setOpenFilter(true);
    };

    // ✅ PAGINATION
    const handlePageChange = (stageId, page, limit = 10) => {
      dispatch(setPage({ stageId, page }));

      dispatch(
        fetchPipeline({
          stage_id: stageId,
          offset: (page - 1) * limit,
        }),
      );
    };

    // ✅ REFRESH SINGLE STAGE
    const handleStageRefresh = (stageId) => {
      setIsRotating(stageId);

      dispatch(
        fetchPipeline({
          stage_id: stageId,
          offset: 0,
        }),
      );

      setTimeout(() => setIsRotating(null), 600);
    };
  const isExit = activeTab === "exit";
  const mainColor = isExit ? "#ee453fb2" : "#169c50";
    return (
    <div className={styles.kanbanWrapper}>
        {/* ✅ LOADER */}
        {loading && <Loader open fullScreen/>}

        {/* ✅ COLUMNS */}
        {stages.map((stage) => (
          <div key={stage.stage_id} className={styles.column}>
            {/* HEADER */}
            <div className={`${styles.columnHeader} ${activeTab==="active" ? styles.active :styles.exit}`}>
              <span>
                {stage.stage} ({stage.total_candidates})
              </span>

              <div className="d-flex gap-2 align-items-center">
                {/* 🔄 REFRESH */}
                <LuRefreshCcw
                  onClick={() => handleStageRefresh(stage.stage_id)}
                  className={`${activeTab==="active" ? styles.refreshactive :styles.refreshexit} ${
                    isRotating === stage.stage_id ? styles.rotate : ""
                  }`}
                />

                {/* 🔍 FILTER */}
                <div
                  className={styles.filterWrapper}
                  onClick={() => handleFilterClick(stage.stage_id, stage.stage)}
                >
                  <PiFunnelBold className={`${styles.filterIcon} ${activeTab==="active" ? styles.refreshactive :styles.refreshexit}`} />

                  {/* 🔴 SHOW DOT IF FILTER APPLIED */}
                  {/* {columnFilters?.[stage.stage_id] && (
                    <span className={styles.redDot}></span>
                  )} */}
                  {pipelineByType[currentType]?.redDotMap?.[stage.stage_id] && (
    <span className={styles.redDot}></span>
  )}
                </div>
              </div>  
            </div>

            {/* ✅ CARDS */}
            <div className={styles.columnContent}>
              {stage.candidates?.length ? (
                stage.candidates.map((candidate) => (
                  <CandidateCard
                    key={candidate.id}
                    data={candidate}
                    stage={stage}
                    menu={menu}
                    activeTab={activeTab}
                    onSelectCandidate={onSelectCandidate}
                  />
                ))
              ) : (
                <div className={styles.EmptyDataError}>
                  <p>No Data Available</p>
                </div>
              )}
            </div>

            {/* ✅ PAGINATION */}
            <div className={styles.pagination}>
              <Pagination
                count={Math.ceil(stage.total_candidates / stage.page_limit)}
                page={pageMap?.[stage.stage_id] || 1}
                onChange={(e, value) =>
                  handlePageChange(stage.stage_id, value, stage.page_limit)
                }
                size="small"
                sx={{
      "& .MuiPaginationItem-root": {
        color: mainColor,
      },
      "& .Mui-selected": {
        backgroundColor: `${mainColor} !important`,
        color: "#fff",
      },
      "& .MuiPaginationItem-root:hover": {
        backgroundColor: `${mainColor}20`,
      },
    }}
              />
            </div>
          </div>
        ))}

        {/* ✅ FILTER MODAL */}
        {openFilter && selectedStage && (
          <MyModal>
            <ModalContainer>
              <StateFilter
                stageId={selectedStage.id}
                stageName={selectedStage.stageName}
                existingFilters={columnFilters?.[selectedStage.id] || {}}
                onClose={() => setOpenFilter(false)}
              />
            </ModalContainer>
          </MyModal>
        )}
      </div>
    );
  };

  export default KanbanBoard;
